import { Checkbox, Select } from "antd";
import React, { useEffect, useState } from "react";
import { DropdownRules } from "../../types/field";
// import { Controller } from "react-hook-form";
import { SelectValue } from "antd/lib/select";
import { GetRequest } from "./../../utils/api";
import CustomLoader from "../loader";

type Props = {
  optionList: Array<any>;
  title: string;
  placeholder: string;
  onChange?: any;
  disabled?: boolean;
  data?: any;
  className?: string;
  dropdownCode?: string;
  dropdownValue?: string;
  enableSearch?: boolean;
  mode?: any;
  allowClear?: boolean;
  loading: boolean;
  rules?: DropdownRules;
  control: any;
  name: string;
  setValue?: any;
  clearValue?: boolean;
  showOnlyValue?: boolean;
};

const DropDown: React.FC<Props> = ({
  optionList,
  loading,
  data,
  onChange,
  placeholder,
  disabled,
  dropdownCode = "code",
  dropdownValue = "name",
  mode = "single",
  rules,
  showOnlyValue
}) => {

  const [selectAll, setSelectAll] = useState(false); // State to track "Select All" checkbox
  const [selectedValues, setSelectedValues] = useState<SelectValue[]>(data ? data : []);

  const filtered = optionList;

  useEffect(() => {
    if (selectedValues.includes('all') || selectedValues.length === filtered.length) {
      setSelectAll(true)
    }
    else {
      setSelectAll(false)
    }

  }, [selectAll]);


  const handleSelectAllOptionClick = () => {
    if (selectAll) {
      setSelectedValues([]);
      setSelectAll(false);
      return [];
    } else {
      const allValues = filtered.map(item => item?.[dropdownCode])?.filter((item: any) => item !== "all");
      setSelectedValues(allValues);
      setSelectAll(true);
      return allValues;
    }
  }

  let dropDownMode = rules?.isMulti ? "multiple" : mode;

  return (


    <div>
      <Select
        className="w-100"
        allowClear={true}
        mode={dropDownMode}
        showSearch
        placeholder={placeholder}
        disabled={disabled}
        loading={loading}
        filterOption={(input, option: any) =>
          option?.title?.toLowerCase().includes(input.toLowerCase())
        }
        onChange={(value) => {
          if (value?.includes("all")) {
            let value = handleSelectAllOptionClick();
            onChange(value);
          } else {
            setSelectAll(false);
            setSelectedValues([]);
            setSelectedValues(value);
            onChange(value);
          }
        }}
        value={selectedValues}
        maxTagCount={1}
        maxTagPlaceholder={`+${selectedValues.length - 1}`}
        options={[
          ...(rules?.isMulti && filtered.length > 0
            ? [{
              key: "all",
              value: "all",
              label: selectAll ? "Unselect All" : "Select All"
            }]
            : []),
          ...optionList.map((item, idx) => ({
            key: idx,
            value: item?.[dropdownCode],
            title: `${item?.[dropdownValue]}-${item?.[dropdownCode]}`, // Use title for filtering
            label: (
              <>
                {rules?.isMulti && (
                  <Checkbox
                    className="mr-2"
                    checked={selectedValues.includes(item?.[dropdownCode])}
                  />
                )}
                {showOnlyValue
                  ? item?.[dropdownValue]
                  : `${item?.[dropdownCode]}-${item?.[dropdownValue]}`}
              </>
            )
          }))
        ]}
      />



    </div>


  );
}


// wrapper component for data fetching... ideally should be done from caller side.
interface CustomDropDownProps {
  title: string;
  placeholder: string;
  onChange?: any;
  disabled?: boolean;
  data?: any;
  className?: string;
  api: string;
  dropdownCode?: string;
  dropdownValue?: string;
  enableSearch?: boolean;
  mode?: any;
  allowClear?: boolean;
  rules?: DropdownRules;
  control: any;
  name: string;
  setValue?: any;
  isCascade?: boolean;
  clearValue?: boolean;
  showOnlyValue?: boolean;
  parentFieldValues?: any;
  parentFieldName?: string;
  // enableSearch: true;
  // disabled: false;
  // mode: undefined;
  // allowClear: false;
  // isCascade: false;
};
const CascadeDropDown: React.FC<CustomDropDownProps> = ({
  title,
  data,
  onChange,
  api,
  placeholder,
  disabled = false,
  dropdownCode,
  dropdownValue,
  enableSearch = true,
  allowClear = false,
  mode = undefined,
  rules,
  control,
  name,
  setValue,
  isCascade = false,
  showOnlyValue,
  parentFieldValues = {},
  parentFieldName,

}) => {
  const [optionList, setOptionList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [clearValue, setClearValues] = useState(false);

  //Todo: move api call to caller and just pass data and remove useeffect.
  const getOptionList = () => {

    if (isCascade && !api.includes("search=")) {
      return;
    }

    setLoading(true);

    if (api?.length > 0) {

      GetRequest(api).then((result: any) => {
        setOptionList(result.records);
        setClearValues(true);
        setLoading(false);
        data = "";
      }).catch((error: Error) => {
        setLoading(false);
        console.log("error", error);
      })

    } else {
      setLoading(false);
    }
  };

  //handle initial loading
  useEffect(() => {

    if (isCascade && !api.includes("search=") && parentFieldName && Object.keys(parentFieldValues).length !== 0 && parentFieldValues[parentFieldName]) {
      api = `${api}&search=${parentFieldName}:in${parentFieldValues[parentFieldName]}`;
      getOptionList();
    }

  }, [parentFieldValues]);

  useEffect(() => {
    getOptionList();
  }, [api]);

  return (
    <>  {!loading && <DropDown
      optionList={optionList}
      loading={loading}
      data={data}
      onChange={onChange}
      placeholder={placeholder}
      disabled={disabled}
      dropdownCode={dropdownCode}
      dropdownValue={dropdownValue}
      enableSearch={enableSearch}
      allowClear={allowClear}
      mode={mode}
      rules={rules}
      control={control}
      name={name}
      title={title}
      setValue={setValue}
      clearValue={clearValue}
      showOnlyValue={showOnlyValue}
    />}
      {loading && <CustomLoader size="sm"></CustomLoader>}
    </>
  );

};


export default CascadeDropDown;
